import { defineStore } from 'pinia';
import type {
  UiNotificationState,
} from '~~/types/vuex/UiNotification';
import type { UiNotification } from '~~/types/components/Notification/UiNotification';

export const uiNotificationStore = defineStore('uiNotification', {
  state: () => ({
    uiNotifications: [],
  }),
  actions: {
    addUiNotification(notification: UiNotification) {

      this.uiNotifications.push(notification); 

    },
    removeUiNotification(notificationId: string) {

      this.uiNotifications = this.uiNotifications.filter(notification => notification.id !== notificationId); 

    },
  },
});
